<div class="ai-chat d-flex flex-column h-100">

  <!-- Panel header -->
  <div class="ai-chat__header d-flex align-items-center px-3 py-2 border-bottom border-secondary flex-shrink-0">
    <span id="assistantTrayLabel" class="fw-semibold text-white fs-6 me-auto">
      Course Assistant
      <span *ngIf="courseName" class="text-secondary fw-normal ms-1 small">— {{ courseName }}</span>
    </span>
    <span class="badge bg-primary ms-2 me-2">AI</span>
    <button
      type="button"
      class="btn-close btn-close-white btn-sm"
      aria-label="Close assistant"
      (click)="close()"
    ></button>
  </div>

  <!-- Message list -->
  <div
    class="ai-chat__messages flex-grow-1 overflow-auto p-3"
    role="log"
    aria-live="polite"
    aria-label="Conversation"
  >

    <!-- Message bubbles -->
    <ng-container *ngFor="let msg of messages">
      <div
        class="ai-chat__bubble d-flex mb-3"
        [class.justify-content-end]="msg.role === 'user'"
        [class.justify-content-start]="msg.role === 'assistant'"
      >
        <div
          class="ai-chat__bubble-body px-3 py-2 rounded-3"
          [class.bg-primary]="msg.role === 'user'"
          [class.text-white]="msg.role === 'user'"
          [class.bg-dark]="msg.role === 'assistant'"
          [class.border]="msg.role === 'assistant'"
          [class.border-secondary]="msg.role === 'assistant'"
          [class.text-light]="msg.role === 'assistant'"
          [attr.aria-label]="(msg.role === 'user' ? 'You' : 'Assistant') + ': ' + msg.content"
        >
          <p class="mb-0 small" style="white-space: pre-wrap;">{{ msg.content }}</p>

          <!-- Action badges -->
          <div *ngIf="msg.actions && msg.actions.length" class="mt-2 d-flex flex-wrap gap-1">
            <span
              *ngFor="let action of msg.actions"
              class="badge bg-secondary text-uppercase"
              style="font-size: 0.65rem; letter-spacing: 0.04em;"
            >{{ action }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Loading state indicator -->
    <div *ngIf="chatState === 'loading'" class="d-flex justify-content-start mb-3">
      <div class="ai-chat__bubble-body px-3 py-2 rounded-3 bg-dark border border-secondary" aria-label="Assistant is typing">
        <span
          class="spinner-border spinner-border-sm text-secondary"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="visually-hidden">Loading response…</span>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="chatState === 'error'" class="alert alert-danger d-flex align-items-center gap-2 py-2" role="alert">
      <span class="flex-grow-1 small">{{ errorMessage }}</span>
      <button
        type="button"
        class="btn btn-sm btn-outline-danger flex-shrink-0"
        (click)="retry()"
        aria-label="Retry last message"
      >Retry</button>
    </div>

    <!-- Quota-exceeded state -->
    <div *ngIf="chatState === 'quota-exceeded'" class="alert alert-warning py-2" role="status">
      <p class="mb-1 fw-semibold small">You've reached your AI chat limit for this period.</p>
      <!-- No text-muted here: in the app's dark theme (`data-bs-theme="dark"`)
           `.text-muted` resolves to rgba(255,255,255,.5), which is near-invisible
           on the light `alert-warning` background and fails WCAG AA. Let the copy
           inherit the alert's own foreground colour; hierarchy comes from the
           semibold headline above vs. this normal-weight line. (COU-870) -->
      <p class="mb-2 small">Upgrade your plan to keep the conversation going.</p>
      <a
        routerLink="/account"
        class="btn btn-sm btn-warning text-dark fw-semibold"
        aria-label="Upgrade your plan"
      >Upgrade plan</a>
    </div>

  </div>

  <!-- Input area — only shown when on a course -->
  <div class="ai-chat__input flex-shrink-0 border-top border-secondary p-3" *ngIf="hasCourse && chatState !== 'quota-exceeded'">
    <div class="input-group">
      <textarea
        #messageInput
        class="form-control form-control-sm bg-dark text-white border-secondary"
        rows="2"
        placeholder="Ask anything about this course…"
        aria-label="Type a message"
        [(ngModel)]="inputText"
        [disabled]="chatState === 'loading'"
        [attr.aria-disabled]="chatState === 'loading' ? 'true' : null"
        (keydown)="onKeydown($event)"
        style="resize: none;"
      ></textarea>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        [disabled]="chatState === 'loading' || !inputText.trim()"
        (click)="sendMessage()"
        aria-label="Send message"
      >
        <span *ngIf="chatState !== 'loading'">Send</span>
        <span *ngIf="chatState === 'loading'" aria-hidden="true">
          <span class="spinner-border spinner-border-sm" role="status"></span>
        </span>
      </button>
    </div>
    <p class="text-secondary small mt-1 mb-0">Enter to send · Shift+Enter for new line</p>
  </div>

  <!-- No-course nudge -->
  <div *ngIf="!hasCourse && chatState !== 'quota-exceeded'" class="ai-chat__no-course flex-shrink-0 border-top border-secondary p-3 text-center text-secondary small">
    <i class="bx bx-map-pin fs-5 d-block mb-1"></i>
    Navigate to a course to start chatting.
  </div>

</div>
